import styled from 'styled-components';

const PROGRAMA_INTEGRIDADE_GREEN = '#0D875E';

/** Protótipo 1920×486 (#0D875E); curva normalizada + deslocamento +0.012 em X no pico. */
const WAVE_CLIP_PATH_DESKTOP =
  'M 0 0.224 C 0 0.224 0.317 0.152 0.512 0.107 C 0.656 0.072 0.87 0.022 0.967 0 C 0.982 0 1 0.06 1 0.141 L 1 1 L 0 1 Z';

const WAVE_CLIP_PATH_MOBILE =
  'M 0 0.18 C 0 0.18 0.362 0.14 0.562 0.11 C 0.732 0.08 0.912 0.03 0.982 0 C 0.995 0 1 0.05 1 0.12 L 1 1 L 0 1 Z';

const waveClipUrl = (pathD: string, clipId: string): string => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg"><defs><clipPath id="${clipId}" clipPathUnits="objectBoundingBox"><path d="${pathD}"/></clipPath></defs></svg>`;
  return `url('data:image/svg+xml,${encodeURIComponent(svg)}#${clipId}')`;
};

const WAVE_CLIP_URL_DESKTOP = waveClipUrl(WAVE_CLIP_PATH_DESKTOP, 'programa-integridade-wave');
const WAVE_CLIP_URL_MOBILE = waveClipUrl(WAVE_CLIP_PATH_MOBILE, 'programa-integridade-wave-mobile');

export const Container = styled.div`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap');

  position: relative;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 56px);
  background-color: #f3f3f3;
  overflow: hidden;

  .programa-integridade-green-bg {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 44%;
    min-height: 300px;
    background-color: ${PROGRAMA_INTEGRIDADE_GREEN};
    clip-path: ${WAVE_CLIP_URL_DESKTOP};
    z-index: 0;

    @media only screen and (max-width: 991px) {
      height: 38%;
      min-height: 240px;
      clip-path: ${WAVE_CLIP_URL_MOBILE};
    }
  }

  .programa-integridade-inner {
    position: relative;
    z-index: 1;
    flex: 1;
    padding: clamp(5.5rem, 12vh, 11.5rem) 1rem 0;
    max-width: min(92rem, 100%);
    margin: 0 auto;
    width: 100%;

    @media only screen and (max-width: 991px) {
      padding: 2rem 1rem 0;
    }
  }

  .programa-integridade-title {
    font-family: 'Poppins', sans-serif;
    color: #21354a;
    font-weight: 700;
    font-size: 2rem;
    line-height: 1.3;
    margin-bottom: 1.75rem;
    max-width: 32.5rem;

    @media only screen and (max-width: 767px) {
      font-size: 1.75rem;
      margin-bottom: 1.25rem;
    }
  }

  /* Bloco de texto ~20% mais largo que o título; limita pela coluna, não por rem solto nos <p> */
  .programa-integridade-text-block {
    max-width: min(100%, calc(32.5rem * 1.2));
  }

  .programa-integridade-text {
    font-family: 'Poppins', sans-serif;
    color: #5c5c5c;
    font-size: 1.125rem;
    line-height: 1.65;
    margin-bottom: 1.25rem;

    strong {
      font-family: inherit;
      color: #21354a;
      font-weight: 700;
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    @media only screen and (max-width: 767px) {
      font-size: 1rem;
    }
  }

  .programa-integridade-form-col {
    display: flex;
    justify-content: flex-end;

    @media only screen and (max-width: 991px) {
      justify-content: stretch;
      margin-top: 2rem;
    }
  }

  .programa-integridade-form-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 47.75rem;
    min-height: 37.5rem;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 28px rgb(0 0 0 / 10%);
    padding: 1rem;
    margin-bottom: 3rem;
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.5;

    label,
    .form-control,
    .btn,
    .alert {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
    }

    @media only screen and (max-width: 991px) {
      max-width: none;
      min-height: unset;
      margin-bottom: 2rem;
    }
  }

  .programa-integridade-form {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 1rem;
    min-height: 0;
  }

  .programa-integridade-form-card label {
    display: block;
    color: #354153;
    font-weight: 500;
    margin-bottom: 0.25rem;
  }

  .programa-integridade-form-card .form-control {
    border-color: #d8dde3;
    border-radius: 4px;
    min-height: 44px;

    &::placeholder {
      color: #adb5bd;
    }

    &:focus {
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 15%);
    }
  }

  .programa-integridade-form-card textarea.form-control {
    flex: 1;
    min-height: 7.5rem;
    resize: vertical;
  }

  .programa-integridade-form-card .form-group {
    margin-bottom: 0;
  }

  .programa-integridade-form-card .form-row {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    gap: 1rem;

    > [class*='col-'] {
      flex: 1 1 0;
      min-width: 0;
      padding: 0;
    }

    > .col-8 {
      flex: 2 1 0;
    }

    > .col-4 {
      flex: 1 1 0;
    }
  }

  .programa-integridade-form .programa-integridade-form-observacao {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  .programa-integridade-submit {
    align-self: flex-start;
    margin-top: 0;
    padding: 0.5rem 1rem;
    font-weight: 500;
    border-radius: 4px;
  }

  .programa-integridade-footer {
    position: relative;
    z-index: 1;
    margin-top: auto;
    text-align: center;
    padding: 1.5rem 1rem 2.75rem;

    img {
      height: 36px;
      width: auto;
    }

    @media only screen and (max-width: 767px) {
      padding-bottom: 2rem;

      img {
        height: 30px;
      }
    }
  }
`;
